"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeTradeTx = void 0;
const caip_1 = require("@shapeshiftoss/caip");
const web3_utils_1 = require("web3-utils");
const api_1 = require("../../../../api");
const getThorTxData_1 = require("./utils/getThorTxData");
const makeTradeTx = async ({ wallet, bip44Params, sellAmountCryptoBaseUnit, buyAsset, sellAsset, destinationAddress, adapter, maxFeePerGas, maxPriorityFeePerGas, gasPriceCryptoBaseUnit, slippageTolerance, deps, gasLimit, buyAssetTradeFeeUsd, }) => {
    try {
        const { assetNamespace } = (0, caip_1.fromAssetId)(sellAsset.assetId);
        const isErc20Trade = assetNamespace === 'erc20';
        const { data, router } = await (0, getThorTxData_1.getThorTxInfo)({
            deps,
            sellAsset,
            buyAsset,
            sellAmountCryptoBaseUnit,
            slippageTolerance,
            destinationAddress,
            buyAssetTradeFeeUsd,
        });
        return adapter.buildCustomTx({
            wallet,
            bip44Params,
            to: router,
            gasLimit,
            ...(gasPriceCryptoBaseUnit !== undefined
                ? { gasPrice: gasPriceCryptoBaseUnit }
                : { maxFeePerGas, maxPriorityFeePerGas }),
            value: isErc20Trade ? '0x0' : (0, web3_utils_1.numberToHex)(sellAmountCryptoBaseUnit),
            data,
        });
    }
    catch (e) {
        if (e instanceof api_1.SwapError)
            throw e;
        throw new api_1.SwapError('[makeTradeTx]: error making trade tx', {
            code: api_1.SwapErrorTypes.BUILD_TRADE_FAILED,
            cause: e,
        });
    }
};
exports.makeTradeTx = makeTradeTx;
